module.exports = __webpack_public_path__ + "img/adsr.5cf72fc8.jpg";